export const TOASTER_DURATION_KEY = 'ui/toaster-duration'
export const TOASTER_DEFAULT_DURATION = 3000
export const TOASTER_MIN_DURATION = 1000
export const TOASTER_MAX_DURATION = 60000
